import { useHomework, setMilestoneValidation, setSelectedHomework } from "./homework";
import { useMemo } from "react";

export default function useNotifications() {
  const [homework, dispatch] = useHomework();

  return useMemo(
    () => ({
      validation_request: (params) =>
        setMilestoneValidation(dispatch, params.milestone, params.from),
      milestone_validation: (params) => setSelectedHomework(dispatch, params.homework),
      milestone_rejection: (params) => setSelectedHomework(dispatch, params.homework),
    }),
    [dispatch]
  );
}
